function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P10 = function P10(_ref) {
  var page = _ref.page;
  var thisPage = 10;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p10-logo').addClass('p10-logo__active');
      }, 1000), setTimeout(function () {
        $('.p10-txt').addClass('p10-txt__active');
      }, 2500), setTimeout(function () {
        $('.p10-txt-mobile').addClass('p10-txt-mobile__active');
      }, 1500), setTimeout(function () {
        $('.p10-fineprint-mobile').addClass('p10-fineprint-mobile__active');
      }, 4500)]);
    } else {
      $('.p10-logo').removeClass('p10-logo__active');
      $('.p10-txt').removeClass('p10-txt__active');
      $('.p10-txt-mobile').removeClass('p10-txt-mobile__active');
      $('.p10-fineprint-mobile').removeClass('p10-fineprint-mobile__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/wash-plant-logo-mobile-blue@3x.png",
    className: "p10-logo"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/make-the@3x.png",
    className: "p10-txt"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/mobile-make-the.png",
    className: "p10-txt-mobile"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/mobile-make-the.png",
    className: "p10-txt-mobile"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/our-high-quality-recycled-sands-and-aggregates-meet-nysdec-reme@3x.png",
    className: "p10-fineprint-mobile"
  }));
};
export default P10;